import { useState } from 'react'
import { Popover, ActionIcon, Stack, Group, Text, Badge, Tooltip } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'
import { APP_VERSION } from '@/version'

export function SystemInfoButton() {
  const [open, setOpen] = useState(false)
  return (
    <Popover opened={open} onChange={setOpen} position="top-end" withArrow shadow="md" width={240}>
      <Popover.Target>
        <Tooltip label="Informações do sistema" withArrow>
          <ActionIcon
            variant="subtle"
            color="gray"
            size="xs"
            aria-label="Informações do sistema"
            onClick={(e) => {
              e.stopPropagation()
              setOpen((v) => !v)
            }}
          >
            <IconInfoCircle size={12} />
          </ActionIcon>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="xs">
          <Text fw={600} size="sm">Informações do sistema</Text>
          <Group justify="space-between">
            <Text size="xs" c="dimmed">Versão</Text>
            <Badge variant="outline" size="xs">v{APP_VERSION}</Badge>
          </Group>
          <Group justify="space-between">
            <Text size="xs" c="dimmed">Backend</Text>
            <Badge variant="outline" size="xs" color="blue">FastAPI + Python</Badge>
          </Group>
          <Group justify="space-between">
            <Text size="xs" c="dimmed">Frontend</Text>
            <Badge variant="outline" size="xs" color="teal">React + Mantine</Badge>
          </Group>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  )
}
